const Switch = {
    defaultProps: {
        colorScheme: 'green',
    },
};

export default Switch;
